import React from 'react'
import { Section, Image, TaglineTitleContent } from 'newComponents'
import { ReactComponent as Dashboard } from '../../../images/home/feature-browser.svg'
import { ReactComponent as FlagUi } from '../../../images/home/feature-bar.svg'
import { ReactComponent as ToggleUi } from '../../../images/home/toggle.svg'
import { ReactComponent as Stars } from '../../../images/home/feature-stars.svg'
import './styles.scss'

const HomeFeature = (props) => {
  const { tagline, title, graphic, columns } = props

  const featureTagline = tagline?.html
  const featureTitle = title?.html

  const featureGraphic = {
    'Dashboard toggle': <DashboardToggle />
  }

  return (
    <Section className="home-feature">
      <Stars className="home-feature-stars" />
      <div className="home-feature-top">
        <div className="home-feature-left">
          <TaglineTitleContent tagline={featureTagline} title={featureTitle} />
        </div>
        <div className="home-feature-right">{featureGraphic[graphic]}</div>
      </div>
      <div className="home-feature-columns">
        {columns.map((column) => {
          const {
            feature_column_title: columnTitle,
            feature_column_content: columnContent,
            feature_column_icon: columnIcon
          } = column
          const columnTitleText = columnTitle?.text
          const columnTitleHtml = columnTitle?.html
          const columnContentHtml = columnContent?.html
          const columnIconUrl = columnIcon?.url

          return (
            <div className="home-feature-column" key={columnTitleText}>
              {columnIconUrl && (
                <Image image={columnIconUrl} alt={columnTitleText} className="home-feature-column-icon" />
              )}
              {columnTitleHtml && (
                <div className="home-feature-column-title" dangerouslySetInnerHTML={{ __html: columnTitleHtml }} />
              )}
              <div className="home-feature-column-content" dangerouslySetInnerHTML={{ __html: columnContentHtml }} />
            </div>
          )
        })}
      </div>
    </Section>
  )
}

const DashboardToggle = () => (
  <div className="home-feature-flags">
    <Dashboard />
    <div className="home-feature-bar">
      <FlagUi className="home-feature-flag" />
      <div className="home-feature-toggle">
        <span className="home-feature-toggle-on">On</span>
        <span className="home-feature-toggle-off">Off</span>
      </div>
    </div>
  </div>
)

export default HomeFeature
